import { createSelector } from 'reselect'
import { get } from 'lodash'

const contacts = state => state.api.contacts.list

const mapForDropdown = orgContacts => {
  return orgContacts.map(item => ({
    value: item.id,
    label: `${item.firstName ||
      get(item, 'person.firstName')} ${item.lastName ||
      get(item, 'person.lastName')} <${item.email ||
      get(item, 'person.email')}>`
  }))
}

export default createSelector(contacts, mapForDropdown)
